import { Component, ViewChild, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { EmailTemplateBasicsItem } from '../../../app/models/domain/email.template.basics.item';
import { EmailTemplateFullItem } from '../../../app/models/domain/email.template.full.item';
import { SendEmailRequest } from '../../../app/models/ss-api/requests/send.email.request';
import { UpdateEmailTemplateRequest } from '../../../app/models/ss-api/requests/update.email.template.request';
import { CKEditorComponent } from 'ng2-ckeditor';
import { Router } from '@angular/router';

export interface IEditEmailTemplateDialog {
    Title: string;
    Template: EmailTemplateBasicsItem;
}

@Component({
    selector: 'edit-email-template-dialog',
    styleUrls: ['./edit.email.template.dialog.css'],
    templateUrl: './edit.email.template.dialog.html'
})

export class EditEmailTemplateDialog extends DialogComponent<IEditEmailTemplateDialog, boolean> implements IEditEmailTemplateDialog, OnInit {
    IsBusy: boolean;
    Title: string;
    Template: EmailTemplateBasicsItem;
    ActiveTemplate: EmailTemplateFullItem;

    ToggleButtonTitle: string = 'Hide Fields';
    FieldsShown: boolean = true;

    @ViewChild('CKEDITOR') CKEDITOR: CKEditorComponent;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.IsBusy = false;
        this.Title = 'Edit Template: ' + this.Template.Name;
        this.LoadTemplate(this.Template.ID);
    }

    ToggleFields() {
        this.FieldsShown = !this.FieldsShown;
        this.ToggleButtonTitle = this.FieldsShown ? 'Hide Fields' : 'Show Fields';
    }

    LoadTemplate(id: number) {
        let disposable = this.api.GetEmailTemplateHTML(id).subscribe(response => {
            this.ActiveTemplate = response.Data;
            disposable.unsubscribe();
        })
    }

    SendTest() {
        this.sweetAlert.swal(
            {
                title: 'Send Test Email',
                text: '',
                input: 'text',
                inputValue: '',
                inputPlaceholder: 'Email address',
                showCancelButton: true,
                preConfirm: (response) => {
                    let request: SendEmailRequest = {
                        Body: this.ActiveTemplate.Body,
                        FromEmail: 'support@structurestudios.com',
                        MemberID: null,
                        Subject: this.ActiveTemplate.Subject,
                        ToBCC: [],
                        ToCC: [],
                        ToEmail: [response]
                    }

                    return this.api.SendEmail(request).toPromise();
                }
            }).then((response: any) => {
                if (response.Result) {
                    this.sweetAlert.swal({
                        title: 'Test Email Sent',
                        text: 'Please check your inbox to see the test email.',
                        type: 'success'
                    })
                } else {
                    this.sweetAlert.swal({
                        type: 'error',
                        title: 'Test Email Failed',
                        text: response.Data
                    })
                }
            }, (dismiss) => {
                return;
            }
            );
    }

    DeleteTemplate() {
        this.sweetAlert.swal({
            type: 'warning',
            title: 'Are you sure?',
            text: 'This action cannot be reversed.',
            showCancelButton: true,
            preConfirm: (response) => {
                // return api promise
                let request = this.Template.ID;

                return this.api.DeleteEmailTemplate(request).toPromise();
            }
        }).then((res) => {
            if (res.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Deleted Successfully',
                    text: 'Email template has been deleted without any errors',
                    timer: 1500
                }).then(() => {
                    this.result = true;
                    this.close();
                }, () => {
                    this.result = true;
                    this.close();
                })
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error',
                    text: res.Message
                }).then(() => { }, () => { })
            }
        }, () => { })
    }

    confirm() {
        this.IsBusy = true;

        if (this.CKEDITOR.instance['mode'] != 'wysiwyg') {

            this.CKEDITOR.instance['commands']['source'].exec()
            setTimeout(() => {
                this.confirm();
            }, 500)

            return false;

        }

        let request: UpdateEmailTemplateRequest = {
            EmailTemplateID: this.ActiveTemplate.ID,
            Body: this.ActiveTemplate.Body,
            CustomDescription: this.ActiveTemplate.Description,
            TemplateType: this.ActiveTemplate.TemplateType,
            EmailTemplateName: this.ActiveTemplate.Name,
            Subject: this.ActiveTemplate.Subject
        }

        let disposable = this.api.UpdateEmailTemplate(request).subscribe(response => {
            this.IsBusy = false;

            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Saved Successfully',
                    text: 'Template has been saved successfully',
                    timer: 1500
                }).then(() => { }, () => { })
                this.close();
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Save Failed',
                    text: response.Message,
                    timer: 1500
                }).then(() => { })
            }

            disposable.unsubscribe();
        })

    }

}
